<template>
  <div class="app-layout-provider">
    <div class="app-layout-provider__content">
      <slot />
    </div>

    <div class="app-layout-provider__dialogs">
    </div>
  </div>
</template>

<script lang="ts" setup>

</script>

<style lang="scss">
.app-layout {
  max-width: 100dvw;
}
</style>
